import { Chip, useTheme } from '@mui/material';

const CheckInCallChip = ({ days }: { days: number }) => {
    const theme = useTheme();
    const colourPallets = () => {
        if (days <= 1) {
            return {
                borderColor: theme.palette.warning.medium,
                backgroundColor: 'rgba(199, 21, 21, 0.3)',
                color: theme.palette.warning.medium,
            };
        } else if (days >= 2 && days <= 7) {
            return {
                borderColor: theme.palette.orange.main,
                backgroundColor: 'rgba(253, 200, 0, 0.3)',
                color: theme.palette.orange.main,
            };
        }
        return {
            borderColor: theme.palette.blue.light,
            backgroundColor: 'rgba(39, 174, 150, 0.3)',
            color: theme.palette.blue.light,
        };
    };
    return (
        <Chip
            label={`${days} Days`}
            variant="outlined"
            data-testid="check-in-call-chip"
            sx={{
                height: '24px',
                borderWidth: 2,
                fontWeight: 500,
                fontSize: '0.75rem',
                border: '1px solid',
                '& .MuiChip-label': {
                    padding: '0 8px',
                },
                width: '80%',
                textAlign: 'center',
                ...colourPallets(),
            }}
        />
    );
};
export default CheckInCallChip;
